/* eslint 'jsx-a11y/alt-text': 'off', eqeqeq: 'off', no-unused-vars: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup, Label, Form, Modal } from 'reactstrap';
import {UpdatePreventativeMaintenanceStandardFields,DeleteUserAddedFieldsFromPM} from '../../../../action/workorderAction';
import closeImage from '../../../../Assets/images/close.png';
import {FaArrowCircleDown as FaDownArrow, FaArrowCircleUp as FaUpArrow} from 'react-icons/fa';
import {MdSave} from 'react-icons/md';
import DraggableList from '../_ModalsForms/DraggableList';
import {Icon} from 'semantic-ui-react';

const headinglabel = {
    fontfamily: 'Verdana',
    fontSize: '14px',
    fontWeight: 'bold'
};

const ErrorPadding = {
    'color': '#D42D27',
    'font-family': 'Lato',
    'font-style': 'italic',
    'border': '2px solid #D42D27',
    'height': '40px',
    'padding': '10px',
    'float': 'left',
    'background-color': '#FFFFFF',
    'font-size': '13px',
    'margin-bottom': '0px',
    'margin-top': '3px'
};

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

class EditPreventativeMaintenanceSetup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:{
                Field:'',
                FieldLabel: '',
                FieldId: this.props.id,
                Value: [],
                Display: true,
                Required: false,
                selectedForSort:''
            },
            actualdata:JSON.parse(this.props.values),
            deletedList:[],
            warning:false,
            IsError: false,
            ErrorMsg: '',
            IsValidationError: false,
            IsFieldLabelError: false,
            IsFieldValueError: false,
        };
        this.OptionChanged = this.OptionChanged.bind(this);
        this.OnEditStandardField = this.OnEditStandardField.bind(this);
        this.AddValues = this.AddValues.bind(this);
        this.ClosePopup = this.ClosePopup.bind(this);
        this.SetSelection = this.SetSelection.bind(this);
        this.MoveUp = this.MoveUp.bind(this);
        this.MoveDown = this.MoveDown.bind(this);
        this.DeleteValue = this.DeleteValue.bind(this);
        this.Sort = this.Sort.bind(this);
    }

    componentWillMount() {
        this.setState({
            actualdata : JSON.parse(this.props.values)
        });
        //scroll to top of the page
        var scrollPageTop = (this.props.Premise) ? document.getElementsByClassName('Ensemble_Content_FullPage') : document.getElementsByClassName('Ensemble_Content');
        if(scrollPageTop[0] !== undefined){
             (this.props.Premise) ? scrollPageTop[0].scrollIntoView() : scrollPageTop[0].scrollTop = 0;
         }
    }

    SetSelection(index) {
        this.setState({ selectedForSort: index });
    }

    MoveUp() {
        if (this.state.selectedForSort != undefined) {
            var saving_data = this.state.actualdata;
            var added_options = [];
            var selectedvalue_orderId = saving_data.value.filter(x => x.index == this.state.selectedForSort)[0].orderId;
            if (selectedvalue_orderId > 0) {
                var next_index = saving_data.value.filter(x => x.orderId == selectedvalue_orderId - 1)[0].index;
                saving_data.value.forEach(el => {
                    if (el.index == this.state.selectedForSort) {
                        el.orderId = selectedvalue_orderId - 1;
                        added_options = this.AddToSaveList(selectedvalue_orderId - 1, el);
                    }
                    if (el.index == next_index) {
                        el.orderId = selectedvalue_orderId;
                        added_options = this.AddToSaveList(selectedvalue_orderId, el);
                    }
                });
                this.setState({ actualdata: saving_data, data: added_options });
            }
        }
    }

    MoveDown() {
        if (this.state.selectedForSort != undefined) {
            var saving_data = this.state.actualdata;
            var index_Array = saving_data.value.map(el => (
                parseInt(el.orderId)
            ));
            var added_options = [];

            var selectedvalue_orderId = saving_data.value.filter(x => x.index == this.state.selectedForSort)[0].orderId;
            if (selectedvalue_orderId < Math.max(...index_Array)) {
                var next_index = saving_data.value.filter(x => x.orderId == selectedvalue_orderId + 1)[0].index;
                saving_data.value.forEach(el => {
                    if (el.index == this.state.selectedForSort) {
                        el.orderId = selectedvalue_orderId + 1;
                        added_options = this.AddToSaveList(selectedvalue_orderId + 1, el);
                    }
                    if (el.index == next_index) {
                        el.orderId = selectedvalue_orderId;
                        added_options = this.AddToSaveList(selectedvalue_orderId, el);
                    }
                });
                this.setState({ actualdata: saving_data, data: added_options });
            }
        }
    }

    Sort(saving_data, added_options)
    {
        this.setState({ actualdata: saving_data, data: added_options });
    }

    AddToSaveList = (order, row) =>
    {
        var added_options = this.state.data;

        if (added_options.Value.filter(x => x.index == row.index).length > 0) {
            added_options.Value.forEach(element => {
                if (element.index == row.index) {
                    element.orderId = order;
                }
            });
        }
        else {
            var lineitem = {
                "key": row.key,
                "value": row.value,
                "isCustom": row.isCustom,
                "index":row.index,
                "orderId":order
            }

            added_options.Value.push(lineitem);
        }
        return added_options;
    }

    OptionChanged(added_options, saving_data) {
        // var added_options = this.state.data;
        // var saving_data = this.state.actualdata;

        // saving_data.value.forEach(el => {
        //     if(el.index == index)
        //     {
        //         el.value = e.target.value;
        //     }
        // });

        // if (added_options.Value.filter(x => x.index == index).length > 0) {
        //     added_options.Value.forEach(element => {
        //         if (element.index == index) {
        //             element.value = e.target.value;
        //         }
        //     });
        // }
        // else {
        //     var lineitem = {
        //         "key": id,
        //         "value": e.target.value,
        //         "isCustom": isCustom,
        //         "index":index,
        //         "orderId":element.orderId
        //     }

        //     added_options.Value.push(lineitem);
        // }

        this.setState({
            data: added_options,
            actualdata: saving_data
        });
    }

    async OnEditStandardField() {
        let IsValid = true;
        this.setState({IsError:false, ErrorMsg: '', IsFieldLabelError:false, IsValidationError:false,IsFieldValueError:false});
        //var selectedOption = this.refs.display_in_Select_input.selectedIndex;
        //var selectedId = this.refs.display_in_Select_input.options[selectedOption].id;
        var RegexRestrictSpecialCharacter =/^[a-zA-Z0-9_\-.,&()$:! ]*$/;
        if (this.refs.required_Yes.checked && !this.refs.display_Yes.checked) {
            IsValid = false;
            this.setState({IsError:true, IsValidationError:true});
        }
        if(this.refs.text_fieldlabel.value === '' || !this.refs.text_fieldlabel.value.match(RegexRestrictSpecialCharacter)){
            IsValid = false;
            this.setState({IsError:true, IsFieldLabelError:true, ErrorMsg: !!this.refs.text_fieldlabel.value === false ? "An entry is required" : "Field Label can only contain letters, numbers, and the following characters _-.,&()$:!"});
        }
        if(this.state.actualdata.fieldId === 1 && this.state.actualdata.value.length === 0){
            IsValid = false;
            this.setState({IsError:true, IsFieldValueError:true, ErrorMsg:"An entry is required"})
        }
        if(IsValid) {
            var saving_data = this.state.data;

            saving_data.Field = this.props.getLabels['PreventativeMaintenance.Options.' + this.props.id + '.Text'];
            saving_data.FieldLabel = this.refs.text_fieldlabel.value;
            saving_data.Required = this.refs.required_Yes.checked;
            saving_data.Display = this.refs.display_Yes.checked;

            // if (this.props.isInitialSetup == true) {
            //     var addInitialSetup = this.props.SaveInitial;
            //     await addInitialSetup();
            //     await this.props.UpdatePreventativeMaintenanceStandardFields(saving_data, this.props.id);
            //         if (this.state.deletedList.length > 0)
            //             this.props.DeleteUserAddedFieldsFromPM(this.state.deletedList, this.props.id);
            // }
            // else {
                this.props.UpdatePreventativeMaintenanceStandardFields(saving_data, this.props.id);
                if (this.state.deletedList.length > 0)
                    this.props.DeleteUserAddedFieldsFromPM(this.state.deletedList, this.props.id);
            // }
            var close = this.props.close;
            close();
            this.setState({IsError:false, IsFieldLabelError:false, IsFieldValueError:false, IsValidationError:false, ErrorMsg:''});
        }
    }

    ClosePopup(){
        this.setState({warning:false});
    }

    AddValues(saving_data,saving_data_actual){

        // if(this.refs.custom_value.value.trim() != "")
        // {
        // var saving_data_actual = this.state.data;
        // var saving_data = this.state.actualdata;

        // var lineitem = {
        //     "key": 0,
        //     "value": this.refs.custom_value.value,
        //     "isCustom": true,
        //     "index": saving_data.value.length,
        //     "orderId": saving_data.value.length

        // }

        // saving_data.value.push(lineitem);
        // saving_data_actual.Value.push(lineitem);

        // this.refs.custom_value.value = "";

        this.setState({actualdata:saving_data, data:saving_data_actual})
        //}
    }

    DeleteValue(saving_data_actual, added_options, deltedList, IsExists) {

        // var IsExists = false;

        // if (this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.1.Text'] && id > 0) {
        //     if (this.props.getList.filter(x => x.status == id).length > 0) {
        //         IsExists = true;
        //     }
        // }
        // if (this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.3.Text'] && id > 0) {
        //     if (this.props.getList.filter(x => x.urgency == id).length > 0) {
        //         IsExists = true;
        //     }
        // }
        // if (this.props.getLabels['WorkOrderSetup.Options.' + this.props.id + '.Text'] == this.props.getLabels['WorkOrderSetup.Options.9.Text'] && id > 0) {
        //     if (this.props.getList.filter(x => x.workOrderDetail.problemID == id).length > 0) {
        //         IsExists = true;
        //     }
        // }

        if (!IsExists) {
            // var added_options = this.state.data;
            // var saving_data_actual = this.state.actualdata;
            // var deltedList = this.state.deletedList;
            // var i = 0;

            // if(id > 0)
            // {
            //     deltedList.push(saving_data_actual.value.filter(x => x.index == index)[0]);
            // }

            // added_options.Value = added_options.Value.filter(x => x.index !== index);
            // saving_data_actual.value = saving_data_actual.value.filter(x => x.index !== index);

            // saving_data_actual.value.forEach(el => {
            //     el.orderId = i;
            //     i+=1;
            // });

            this.setState({ actualdata: saving_data_actual, data: added_options, deletedList: deltedList});
        }
        else
        {
            this.setState({warning:!this.state.warning});
        }
    }

    render(){
        let label = this.props.getLabels;
        var errormsg ='';
        if(this.state.IsError){
            errormsg = <p style={ErrorPadding} ><Icon name='exclamation triangle' style={ErrorSign} /><b> {(!this.state.IsValidationError ? "Please correct all errors before continuing.": label['SetupValidationError.Text'])}</b></p>
        }

        if(this.state.actualdata.value != "--")
        {
        const sortedData = this.state.actualdata.value.sort((a, b) => {
            var nameA = a['orderId'];
            var nameB = b['orderId'];

            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.actualdata.value = sortedData;
    }

        var value_list = "";
        //eslint-disable-next-line
        var value_grid = "--";
        //eslint-disable-next-line
        var display_on_page = <select style={{ width: '100%' }} ref='display_in_Select_input' defaultValue={this.state.actualdata.display ? 1 : 0}>
            <option id={0} value={0}>{label['WorkOrderSetup.No.Text']}</option>
            <option id={1} value={1}>{label['WorkOrderSetup.Yes.Text']}</option>
        </select>

        if (this.state.actualdata.value != "--") {
            value_list = this.state.actualdata.value.map(el => (
                <tr>
                    {/* <td><input type="checkbox" /></td> */}
                    <td><input type="text" value={el.value} style={{border: "0px solid #000000", backgroundColor: "lightgrey", width:"320px"}} onClick={()=>{this.SetSelection(el.index)}} onChange={(e) => this.OptionChanged(el.key,el.isCustom,el.index,el,e)} /></td>
                    <td><img src={closeImage} onClick={() =>{this.DeleteValue(el.index,el.key,el.field)}} style={{width:"15px",height:"15px"}} /></td>
                </tr>
            ));
            value_grid = <div style={{width:"400px"}}><input type="text" ref='custom_value'/><Button type="button" className="btn btn-success" onClick={this.AddValues}>{label['WorkOrders.Add.Text']}</Button><br /><table><tr><td><table>{value_list}</table></td><td><FaUpArrow onClick={this.MoveUp} style={{width: "20px", height: "20px"}}/>&nbsp;&nbsp;&nbsp;<FaDownArrow onClick={this.MoveDown} style={{width: "20px", height: "20px"}}/></td></tr></table></div>
        }

    return(
        <div className="main_container">
            <Form>
                <FormGroup row>
                    <Col sm={{size:12}}>
                        {errormsg}
                    </Col>
                </FormGroup>
                <FormGroup>
                    <Label style={headinglabel}>{label['WorkOrderSetup.Standards.Edit.Text']}</Label>
                    <div style={{float: 'right'}}>
                        <table>
                            <tr>
                                {/* <td><Label className="link_cursorUnderline" onClick={this.props.close}>{label['WorkOrders.CreateTenant.Cancel.Text']}</Label></td>
                                <td>|</td>
                                <td><MdSave style={{width: '25px', height: '25px'}} onClick={this.OnEditStandardField} /></td> */}
                                <td><div className="workorderbtn-save" id="btnSave_PmSetup" style={{"margin-left":"10px"}} onClick={this.OnEditStandardField} ><MdSave style={{width: '15px', height: '15px'}} /> SAVE</div></td>
                                <td><div className="workorderbtn-cancel" id="btnCancel_PmSetup" style={{"margin-left":"10px"}} onClick={this.props.close}> CANCEL</div></td>
                            </tr>
                        </table>
                    </div>
                </FormGroup>
                <hr style={{backgroundColor:'#666666',height:'1px',border:'none'}}/>
                <FormGroup row style={{marginBottom:'3px'}}>
                    <Col sm={{ size: 4 }}>
                        <Label style={headinglabel}>{label['WorkOrderSetup.FieldName.Text']}</Label><br/>
                        <Label>{label['PreventativeMaintenance.Options.'+ this.props.id +'.Text']}</Label><br/>
                    </Col> 
                </FormGroup>
                <br/>
                <FormGroup row>
                    <Col sm={{ size: 4 }}>
                        <Label className={(this.state.IsFieldLabelError) ? "errortext" :""} style={headinglabel}>{label['WorkOrderSetup.FieldLabel.Text']+"*"}</Label><br/>
                        <input type="text" maxLength="50" ref='text_fieldlabel' id="txtname_Pmsetup" className={(this.state.IsFieldLabelError) ? "errorhighlight wo_setup_fieldvalue" : "wo_setup_fieldvalue"} defaultValue={this.state.actualdata.fieldLabel}/>
                        <span hidden={!this.state.IsFieldLabelError}><Icon name='exclamation triangle' style={ErrorSign} />
                            {(this.state.IsFieldLabelError)? <Label className="wo_employee_errortext" style={{display:"block", marginBottom:"0px"}}>{this.state.ErrorMsg}</Label> : ""}
                        </span>
                    </Col> 
                </FormGroup>
                <br/>
                {/* <FormGroup row>
                    <Col sm={{ size: 4 }}>
                    <Label style={headinglabel}>{label['WorkOrders.Heading.Description.Text']}</Label><br/>
                    </Col>  
                    <Col sm={{ size: 4 }}>
                    <textarea rows="5" ref='text_description' style={{width:"320px"}} defaultValue={this.state.actualdata.description} />
                    </Col> 
                </FormGroup> */}
                <FormGroup row>
                    <Col sm={{ size: 4 }}>
                        <Label style={headinglabel}>{this.state.actualdata.value !=="--" ? label['WorkOrderSetup.Values.Text']+"*" : label['WorkOrderSetup.Values.Text']}</Label>
                        <span hidden={!this.state.IsFieldValueError}><Icon name='exclamation triangle' style={ErrorSign} />
                            {(this.state.IsFieldValueError)? <Label className="wo_employee_errortext" style={{marginBottom:"0px",paddingLeft:"3px"}}>{this.state.ErrorMsg}</Label> : ""}
                        </span>
                        <br/>
                        {this.state.actualdata.value != "--" ?
                        <DraggableList options={this.state.actualdata} AddOptions={this.AddValues} DeleteOptions={this.DeleteValue} UpdateOptions={this.OptionChanged} SortOptions={this.Sort} id={this.props.id} fromWorkOrder={this.props.fromWorkOrder} /> : "--"}
                    {/* {value_grid} */}
                    </Col> 
                </FormGroup>
                <br/>
                <FormGroup row style={{marginBottom:'25px'}}>
                    <Col sm={{ size: 4 }}>
                        <Label style={headinglabel}>{label['WorkOrders.Heading.Required.Text']+"*"}</Label><br/>
                        <input type='radio' ref='required_No' defaultChecked={!this.state.actualdata.required} name='Required' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br/>
                        <input type='radio' ref='required_Yes' defaultChecked={this.state.actualdata.required} name='Required' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label>
                    </Col> 
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size: 4 }}>
                        <Label style={headinglabel}>{label['WorkOrderSetup.DisplayOnPage.Text']+"*"}</Label><br/>
                        <input type='radio' ref='display_No' defaultChecked={!this.state.actualdata.display} name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.No.Text']}</Label><br/>
                        <input type='radio' ref='display_Yes' defaultChecked={this.state.actualdata.display} name='displayOnPage' /><Label>&nbsp;{label['WorkOrderSetup.Yes.Text']}</Label>
                    {/* </Col>  
                    <Col sm={{ size: 4 }}>
                        {display_on_page} */}

                    </Col> 
                </FormGroup>
                
                {/* <FormGroup row>
                <Button type="button" className="btn btn-black" onClick={this.props.close} >{label['WorkOrders.CreateTenant.Cancel.Text'] !== undefined ? label['WorkOrders.CreateTenant.Cancel.Text'] : "Cancel"} </Button>
                <Button type="button" className="btn-black btn-md" onClick={this.OnEditStandardField} >{label['WorkOrders.CreateTenant.Save.Text'] !== undefined ? label['WorkOrders.CreateTenant.Save.Text'] : "Save"}</Button>
                </FormGroup> */}
                 <div className="workorderlbl-noentry">*required fields </div>
            </Form>
           
            <Modal isOpen={this.state.warning} >
            <div className="delete_confirmation_Modal">
                <div id="txt_Delete_UAText" className="delete_msg_content">
                The selected option is associated with workorder(s) / preventative Maintenance. Unable to delete the selected option
                </div>
             
                
                    <FormGroup row >
                        <Col sm={{ size: 12 }}>
                            <Button id="btn_NoDelete" className="btn-gray btn-md ChangeLimits_Applybtn"   onClick={this.ClosePopup}>Close</Button>                    
                        </Col>
                    </FormGroup>
            </div>
            </Modal>
        </div>
        );
        }
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getList: state.WorkorderRootReducer.WorkOrderList
    };
};

const mapDispatchToProps = dispatch =>{
    return {
        UpdatePreventativeMaintenanceStandardFields: (data,id) => dispatch(UpdatePreventativeMaintenanceStandardFields(data, id)),
        DeleteUserAddedFieldsFromPM: (data,id) => dispatch(DeleteUserAddedFieldsFromPM(data,id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPreventativeMaintenanceSetup);